import { type } from "arktype";

export const authSignUpSchema = type({
	emailAddress: type("string.email").configure({
		message: (ctx) =>
			ctx.data
				? "The email address is invalid."
				: "The email address is required.",
	}),
	userName: type("string")
		.moreThanLength(2)
		.configure({
			message: (ctx) =>
				ctx.data
					? "The username must be at least 3 characters long."
					: "The username is required.",
		}),
	password: type("string")
		.moreThanLength(0)
		.moreThanLength(7)
		.configure({
			message: (ctx) =>
				ctx.data
					? "The password mus be at least 8 characters long."
					: "The password is required.",
		}),
	languageCode: type("string")
		.moreThanLength(0)
		.exactlyLength(2)
		.configure({ message: () => "The language is required." }),
	publisherID: type("string.numeric.parse")
		.or("number")
		.configure({
			message: () => "The publisher ID is invalid.",
		}),
	secretCode: type("string")
		.moreThanLength(0)
		.configure({ message: () => "The secret code is required." }),
});

export type AuthSignUpInput = typeof authSignUpSchema.infer;
